import Lost from '../assets/404.png'
import usePaperlessNavigate from "../hooks/usePaperlessNavigate";

const NotFound = () => {
    const {paperlessNavigate} = usePaperlessNavigate();
    const handleGoHome = () => {
        paperlessNavigate(
            {
                destination: `/`,
                payload: ''
            })
    }

    return (
        <>
            <p className={'page-title'}>Page Not Found </p>
            <div className={'flex flex-col justify-center items-center'}>
                <img src={Lost} alt={'Not found'}/>

                <button type={'button'} onClick={handleGoHome} className="button-slide" id="button-2">
                    <div id="slide"></div>
                    <span> Go Home! </span>
                </button>
            </div>

        </>
    )
};

export default NotFound;